// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3P5kw","rightAdornment":"Header_rightAdornment__3Nupz"};